export default function percentOperation(first, second) {
    return (second / first) * 100;
}
